import { render, staticRenderFns } from "./ResetPasswordSubmitPage.vue?vue&type=template&id=65f0e96e&scoped=true"
import script from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordSubmitPage.vue?vue&type=script&lang=ts"
import style0 from "./ResetPasswordSubmitPage.vue?vue&type=style&index=0&id=65f0e96e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0e96e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f0e96e')) {
      api.createRecord('65f0e96e', component.options)
    } else {
      api.reload('65f0e96e', component.options)
    }
    module.hot.accept("./ResetPasswordSubmitPage.vue?vue&type=template&id=65f0e96e&scoped=true", function () {
      api.rerender('65f0e96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/ResetPasswordSubmitPage.vue"
export default component.exports